import { createAsyncThunk } from '@reduxjs/toolkit';
import { ValidationErrors } from '@/interfaces/common';
import { axiosData } from '@/axios';

import type { AxiosError, AxiosResponse } from 'axios';

const modulePrefix = '/embajadores';

export interface EmbajadorData {
  IdConsultor: number;
  Nombre: string;
  Telefono: string;
  Email: string;
  IdPais: number;
  IdProvincia: number;
  IdLocalidad: number;
  CodigoAreaTelefono: string;
  IdEstado: number;
  localidad: EmbajadorGenericData;
  pais: EmbajadorGenericData;
  provincia: EmbajadorGenericData;
  perfil_foto: string;
  ig: string;
}

export interface EmbajadorGenericData {
  Nombre: string;
}

export interface EmbajadoresResponse {
  data: EmbajadorData[];
}

export interface EmbajadoresProps {
  page?: number;
}

export const getEmbajadores = createAsyncThunk(
  `${modulePrefix}/getEmbajadores`,
  async (props: EmbajadoresProps | undefined, { rejectWithValue }) => {
    try {
      const url = '/embajadores?includes=pais,provincia,localidad&limit=5000&IdEstado=1';
      const data: AxiosResponse = await axiosData.get(url, {});
      const result: EmbajadoresResponse = data.data;
      return result;
    } catch (err: any) {
      const error: AxiosError<ValidationErrors> = err;
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
